// Generated by scripts/generate_subscription_country_pricing.mjs. Do not edit manually.
export const subscriptionCountryPricingVersion = "wb-ppp-2025-v2";

export const subscriptionCountryPricingSources = Object.freeze({
  generatedAt: "2026-07-24T04:07:12.998Z",
  methodology: "World Bank purchasing power parity, official exchange rates and income groups, with parent-economy proxies for territories and Taiwan official FX",
  countriesUrl: "https://api.worldbank.org/v2/country?format=json&per_page=400",
  pppUrl: "https://api.worldbank.org/v2/country/all/indicator/PA.NUS.PPP?format=json&per_page=400&mrnev=1",
  fxUrl: "https://api.worldbank.org/v2/country/all/indicator/PA.NUS.FCRF?format=json&per_page=400&mrnev=1",
  taiwanFxUrl: "https://www.cbc.gov.tw/en/cp-480-58819-C8475-2.html",
  baseCountry: "AU",
  basePpp: 1.398943,
  baseFx: 1.5519978866485
});

export const subscriptionCountryPricingData = Object.freeze({
  "AC": {
    "name": "Ascension Island",
    "iso3": "",
    "currency": "shp",
    "incomeLevel": "HIC",
    "ppp": 0.677133,
    "pppYear": 2025,
    "fx": 0.759473957338608,
    "fxYear": 2025,
    "pricingDataType": "territory_proxy",
    "pricingProxyCountryCode": "GB",
    "pricingCurrencyMultiplier": 1
  },
  "AD": {
    "name": "Andorra",
    "iso3": "AND",
    "currency": "eur",
    "incomeLevel": "HIC",
    "ppp": 0.603848577368125,
    "pppYear": 2025,
    "fx": 0.887144250370588,
    "fxYear": 2025
  },
  "AE": {
    "name": "United Arab Emirates",
    "iso3": "ARE",
    "currency": "aed",
    "incomeLevel": "HIC",
    "ppp": 2.32695589646038,
    "pppYear": 2024,
    "fx": 3.6725,
    "fxYear": 2025
  },
  "AF": {
    "name": "Afghanistan",
    "iso3": "AFG",
    "currency": "afn",
    "incomeLevel": "LIC",
    "ppp": 13.2320571626481,
    "pppYear": 2024,
    "fx": 76.8135364354897,
    "fxYear": 2020
  },
  "AG": {
    "name": "Antigua and Barbuda",
    "iso3": "ATG",
    "currency": "xcd",
    "incomeLevel": "HIC",
    "ppp": 1.87014584555665,
    "pppYear": 2025,
    "fx": 2.7,
    "fxYear": 2025
  },
  "AI": {
    "name": "Anguilla",
    "iso3": "",
    "currency": "xcd",
    "incomeLevel": "HIC",
    "ppp": 1.87014584555665,
    "pppYear": 2025,
    "fx": 2.7,
    "fxYear": 2025,
    "pricingDataType": "territory_proxy",
    "pricingProxyCountryCode": "AG",
    "pricingCurrencyMultiplier": 1
  },
  "AL": {
    "name": "Albania",
    "iso3": "ALB",
    "currency": "all",
    "incomeLevel": "UMC",
    "ppp": 39.9805375942293,
    "pppYear": 2025,
    "fx": 93.1233333333333,
    "fxYear": 2024
  },
  "AM": {
    "name": "Armenia",
    "iso3": "ARM",
    "currency": "amd",
    "incomeLevel": "UMC",
    "ppp": 148.11782018569,
    "pppYear": 2025,
    "fx": 387.010152166483,
    "fxYear": 2025
  },
  "AO": {
    "name": "Angola",
    "iso3": "AGO",
    "currency": "aoa",
    "incomeLevel": "LMC",
    "ppp": 322.965962233887,
    "pppYear": 2025,
    "fx": 911.99303781631,
    "fxYear": 2025
  },
  "AR": {
    "name": "Argentina",
    "iso3": "ARG",
    "currency": "ars",
    "incomeLevel": "UMC",
    "ppp": 567.297421343424,
    "pppYear": 2025,
    "fx": 1240.85125,
    "fxYear": 2025
  },
  "AS": {
    "name": "American Samoa",
    "iso3": "ASM",
    "currency": "usd",
    "incomeLevel": "HIC",
    "ppp": null,
    "pppYear": null,
    "fx": 1,
    "fxYear": 2025
  },
  "AT": {
    "name": "Austria",
    "iso3": "AUT",
    "currency": "eur",
    "incomeLevel": "HIC",
    "ppp": 0.725357,
    "pppYear": 2025,
    "fx": 0.88496895841236,
    "fxYear": 2025
  },
  "AU": {
    "name": "Australia",
    "iso3": "AUS",
    "currency": "aud",
    "incomeLevel": "HIC",
    "ppp": 1.398943,
    "pppYear": 2025,
    "fx": 1.5519978866485,
    "fxYear": 2025
  },
  "AW": {
    "name": "Aruba",
    "iso3": "ABW",
    "currency": "awg",
    "incomeLevel": "HIC",
    "ppp": 1.3358003334369,
    "pppYear": 2024,
    "fx": 1.79,
    "fxYear": 2025
  },
  "AX": {
    "name": "Åland Islands",
    "iso3": "",
    "currency": "eur",
    "incomeLevel": "HIC",
    "ppp": 0.754195,
    "pppYear": 2025,
    "fx": 0.88496895841236,
    "fxYear": 2025,
    "pricingDataType": "territory_proxy",
    "pricingProxyCountryCode": "FI",
    "pricingCurrencyMultiplier": 1
  },
  "AZ": {
    "name": "Azerbaijan",
    "iso3": "AZE",
    "currency": "azn",
    "incomeLevel": "UMC",
    "ppp": 0.482459128195909,
    "pppYear": 2025,
    "fx": 1.7,
    "fxYear": 2025
  },
  "BA": {
    "name": "Bosnia and Herzegovina",
    "iso3": "BIH",
    "currency": "bam",
    "incomeLevel": "UMC",
    "ppp": 0.697646964731518,
    "pppYear": 2025,
    "fx": 1.73592901689708,
    "fxYear": 2025
  },
  "BB": {
    "name": "Barbados",
    "iso3": "BRB",
    "currency": "bbd",
    "incomeLevel": "HIC",
    "ppp": 2.19085217304192,
    "pppYear": 2025,
    "fx": 2,
    "fxYear": 2025
  },
  "BD": {
    "name": "Bangladesh",
    "iso3": "BGD",
    "currency": "bdt",
    "incomeLevel": "LMC",
    "ppp": 30.9160155190794,
    "pppYear": 2025,
    "fx": 121.920836605034,
    "fxYear": 2025
  },
  "BE": {
    "name": "Belgium",
    "iso3": "BEL",
    "currency": "eur",
    "incomeLevel": "HIC",
    "ppp": 0.719942,
    "pppYear": 2025,
    "fx": 0.88496895841236,
    "fxYear": 2025
  },
  "BF": {
    "name": "Burkina Faso",
    "iso3": "BFA",
    "currency": "xof",
    "incomeLevel": "LIC",
    "ppp": 217.410761840348,
    "pppYear": 2025,
    "fx": 581.92848104034,
    "fxYear": 2025
  },
  "BG": {
    "name": "Bulgaria",
    "iso3": "BGR",
    "currency": "bgn",
    "incomeLevel": "HIC",
    "ppp": 0.405704596599949,
    "pppYear": 2025,
    "fx": 1.73519166666667,
    "fxYear": 2025
  },
  "BH": {
    "name": "Bahrain",
    "iso3": "BHR",
    "currency": "bhd",
    "incomeLevel": "HIC",
    "ppp": 0.162039933977081,
    "pppYear": 2025,
    "fx": 0.376,
    "fxYear": 2025
  },
  "BI": {
    "name": "Burundi",
    "iso3": "BDI",
    "currency": "bif",
    "incomeLevel": "LIC",
    "ppp": 999.612019047394,
    "pppYear": 2025,
    "fx": 2943.1375,
    "fxYear": 2025
  },
  "BJ": {
    "name": "Benin",
    "iso3": "BEN",
    "currency": "xof",
    "incomeLevel": "LMC",
    "ppp": 200.336598367492,
    "pppYear": 2025,
    "fx": 581.92848104034,
    "fxYear": 2025
  },
  "BL": {
    "name": "St. Barthélemy",
    "iso3": "",
    "currency": "eur",
    "incomeLevel": "HIC",
    "ppp": 0.677618,
    "pppYear": 2025,
    "fx": 0.88496895841236,
    "fxYear": 2025,
    "pricingDataType": "territory_proxy",
    "pricingProxyCountryCode": "FR",
    "pricingCurrencyMultiplier": 1
  },
  "BM": {
    "name": "Bermuda",
    "iso3": "BMU",
    "currency": "bmd",
    "incomeLevel": "HIC",
    "ppp": 1.19812062185577,
    "pppYear": 2024,
    "fx": 1,
    "fxYear": 2025
  },
  "BN": {
    "name": "Brunei Darussalam",
    "iso3": "BRN",
    "currency": "bnd",
    "incomeLevel": "HIC",
    "ppp": 0.456019597784343,
    "pppYear": 2025,
    "fx": 1.307595108858,
    "fxYear": 2025
  },
  "BO": {
    "name": "Bolivia",
    "iso3": "BOL",
    "currency": "bob",
    "incomeLevel": "LMC",
    "ppp": 2.76324583616839,
    "pppYear": 2025,
    "fx": 6.91,
    "fxYear": 2025
  },
  "BQ": {
    "name": "Caribbean Netherlands",
    "iso3": "",
    "currency": "usd",
    "incomeLevel": "HIC",
    "ppp": 1,
    "pppYear": 2025,
    "fx": 1,
    "fxYear": 2025,
    "pricingDataType": "territory_proxy",
    "pricingProxyCountryCode": "US",
    "pricingCurrencyMultiplier": 1
  },
  "BR": {
    "name": "Brazil",
    "iso3": "BRA",
    "currency": "brl",
    "incomeLevel": "UMC",
    "ppp": 2.55440835439356,
    "pppYear": 2025,
    "fx": 5.58728623856661,
    "fxYear": 2025
  },
  "BS": {
    "name": "Bahamas, The",
    "iso3": "BHS",
    "currency": "bsd",
    "incomeLevel": "HIC",
    "ppp": 0.956315655509349,
    "pppYear": 2024,
    "fx": 1,
    "fxYear": 2025
  },
  "BT": {
    "name": "Bhutan",
    "iso3": "BTN",
    "currency": "inr",
    "incomeLevel": "LMC",
    "ppp": 19.9848946493305,
    "pppYear": 2025,
    "fx": 87.1584483507393,
    "fxYear": 2025
  },
  "BV": {
    "name": "Bouvet Island",
    "iso3": "",
    "currency": "nok",
    "incomeLevel": "HIC",
    "ppp": 9.451661,
    "pppYear": 2025,
    "fx": 10.3958333333333,
    "fxYear": 2025,
    "pricingDataType": "territory_proxy",
    "pricingProxyCountryCode": "NO",
    "pricingCurrencyMultiplier": 1
  },
  "BW": {
    "name": "Botswana",
    "iso3": "BWA",
    "currency": "bwp",
    "incomeLevel": "UMC",
    "ppp": 5.07409138676734,
    "pppYear": 2025,
    "fx": 13.5023833333333,
    "fxYear": 2025
  },
  "BY": {
    "name": "Belarus",
    "iso3": "BLR",
    "currency": "byn",
    "incomeLevel": "UMC",
    "ppp": 0.90876978092131,
    "pppYear": 2025,
    "fx": 3.069175,
    "fxYear": 2025
  },
  "BZ": {
    "name": "Belize",
    "iso3": "BLZ",
    "currency": "bzd",
    "incomeLevel": "UMC",
    "ppp": 1.05113051635175,
    "pppYear": 2025,
    "fx": 2,
    "fxYear": 2025
  },
  "CA": {
    "name": "Canada",
    "iso3": "CAN",
    "currency": "cad",
    "incomeLevel": "HIC",
    "ppp": 1.166683,
    "pppYear": 2025,
    "fx": 1.39810565893901,
    "fxYear": 2025
  },
  "CC": {
    "name": "Cocos (Keeling) Islands",
    "iso3": "",
    "currency": "aud",
    "incomeLevel": "HIC",
    "ppp": 1.398943,
    "pppYear": 2025,
    "fx": 1.5519978866485,
    "fxYear": 2025,
    "pricingDataType": "territory_proxy",
    "pricingProxyCountryCode": "AU",
    "pricingCurrencyMultiplier": 1
  },
  "CD": {
    "name": "Congo, Dem. Rep.",
    "iso3": "COD",
    "currency": "cdf",
    "incomeLevel": "LIC",
    "ppp": 1124.85430376458,
    "pppYear": 2025,
    "fx": 2693.24060103248,
    "fxYear": 2025
  },
  "CF": {
    "name": "Central African Republic",
    "iso3": "CAF",
    "currency": "xaf",
    "incomeLevel": "LIC",
    "ppp": 246.31590787299,
    "pppYear": 2025,
    "fx": 581.92848104034,
    "fxYear": 2025
  },
  "CG": {
    "name": "Congo, Rep.",
    "iso3": "COG",
    "currency": "xaf",
    "incomeLevel": "LMC",
    "ppp": 201.890946598546,
    "pppYear": 2025,
    "fx": 581.92848104034,
    "fxYear": 2025
  },
  "CH": {
    "name": "Switzerland",
    "iso3": "CHE",
    "currency": "chf",
    "incomeLevel": "HIC",
    "ppp": 0.930746,
    "pppYear": 2025,
    "fx": 0.831355833333334,
    "fxYear": 2025
  },
  "CI": {
    "name": "Cote d'Ivoire",
    "iso3": "CIV",
    "currency": "xof",
    "incomeLevel": "LMC",
    "ppp": 216.221332210196,
    "pppYear": 2025,
    "fx": 581.92848104034,
    "fxYear": 2025
  },
  "CK": {
    "name": "Cook Islands",
    "iso3": "",
    "currency": "nzd",
    "incomeLevel": "HIC",
    "ppp": 1.472957,
    "pppYear": 2025,
    "fx": 1.72010833333333,
    "fxYear": 2025,
    "pricingDataType": "territory_proxy",
    "pricingProxyCountryCode": "NZ",
    "pricingCurrencyMultiplier": 1
  },
  "CL": {
    "name": "Chile",
    "iso3": "CHL",
    "currency": "clp",
    "incomeLevel": "HIC",
    "ppp": 453.188563,
    "pppYear": 2025,
    "fx": 951.329454191033,
    "fxYear": 2025
  },
  "CM": {
    "name": "Cameroon",
    "iso3": "CMR",
    "currency": "xaf",
    "incomeLevel": "LMC",
    "ppp": 198.309241557697,
    "pppYear": 2025,
    "fx": 581.92848104034,
    "fxYear": 2025
  },
  "CN": {
    "name": "China",
    "iso3": "CHN",
    "currency": "cny",
    "incomeLevel": "UMC",
    "ppp": 3.39768588417447,
    "pppYear": 2025,
    "fx": 7.18984737402171,
    "fxYear": 2025
  },
  "CO": {
    "name": "Colombia",
    "iso3": "COL",
    "currency": "cop",
    "incomeLevel": "UMC",
    "ppp": 1532.719303,
    "pppYear": 2025,
    "fx": 4053.13583333333,
    "fxYear": 2025
  },
  "CR": {
    "name": "Costa Rica",
    "iso3": "CRI",
    "currency": "crc",
    "incomeLevel": "HIC",
    "ppp": 297.351768,
    "pppYear": 2025,
    "fx": 503.496832373272,
    "fxYear": 2025
  },
  "CU": {
    "name": "Cuba",
    "iso3": "CUB",
    "currency": "cup",
    "incomeLevel": "UMC",
    "ppp": 0.321938711455632,
    "pppYear": 2011,
    "fx": 0.821999999,
    "fxYear": 1974
  },
  "CV": {
    "name": "Cabo Verde",
    "iso3": "CPV",
    "currency": "cve",
    "incomeLevel": "UMC",
    "ppp": 46.629436004152,
    "pppYear": 2025,
    "fx": 97.8631517010164,
    "fxYear": 2025
  },
  "CW": {
    "name": "Curacao",
    "iso3": "CUW",
    "currency": "xcg",
    "incomeLevel": "HIC",
    "ppp": 1.24831756717631,
    "pppYear": 2024,
    "fx": 1.79,
    "fxYear": 2025
  },
  "CX": {
    "name": "Christmas Island",
    "iso3": "",
    "currency": "aud",
    "incomeLevel": "HIC",
    "ppp": 1.398943,
    "pppYear": 2025,
    "fx": 1.5519978866485,
    "fxYear": 2025,
    "pricingDataType": "territory_proxy",
    "pricingProxyCountryCode": "AU",
    "pricingCurrencyMultiplier": 1
  },
  "CY": {
    "name": "Cyprus",
    "iso3": "CYP",
    "currency": "eur",
    "incomeLevel": "HIC",
    "ppp": 0.572620273384741,
    "pppYear": 2025,
    "fx": 0.88496895841236,
    "fxYear": 2025
  },
  "CZ": {
    "name": "Czechia",
    "iso3": "CZE",
    "currency": "czk",
    "incomeLevel": "HIC",
    "ppp": 12.993503,
    "pppYear": 2025,
    "fx": 21.882,
    "fxYear": 2025
  },
  "DE": {
    "name": "Germany",
    "iso3": "DEU",
    "currency": "eur",
    "incomeLevel": "HIC",
    "ppp": 0.709983,
    "pppYear": 2025,
    "fx": 0.88496895841236,
    "fxYear": 2025
  },
  "DG": {
    "name": "Diego Garcia",
    "iso3": "",
    "currency": "usd",
    "incomeLevel": "HIC",
    "ppp": 1,
    "pppYear": 2025,
    "fx": 1,
    "fxYear": 2025,
    "pricingDataType": "territory_proxy",
    "pricingProxyCountryCode": "US",
    "pricingCurrencyMultiplier": 1
  },
  "DJ": {
    "name": "Djibouti",
    "iso3": "DJI",
    "currency": "djf",
    "incomeLevel": "LMC",
    "ppp": 82.1238304290602,
    "pppYear": 2025,
    "fx": 177.721,
    "fxYear": 2025
  },
  "DK": {
    "name": "Denmark",
    "iso3": "DNK",
    "currency": "dkk",
    "incomeLevel": "HIC",
    "ppp": 6.124666,
    "pppYear": 2025,
    "fx": 6.62182508333333,
    "fxYear": 2025
  },
  "DM": {
    "name": "Dominica",
    "iso3": "DMA",
    "currency": "xcd",
    "incomeLevel": "UMC",
    "ppp": 1.30631128267932,
    "pppYear": 2025,
    "fx": 2.7,
    "fxYear": 2025
  },
  "DO": {
    "name": "Dominican Republic",
    "iso3": "DOM",
    "currency": "dop",
    "incomeLevel": "UMC",
    "ppp": 23.8682512750234,
    "pppYear": 2025,
    "fx": 61.9865666666667,
    "fxYear": 2025
  },
  "DZ": {
    "name": "Algeria",
    "iso3": "DZA",
    "currency": "dzd",
    "incomeLevel": "UMC",
    "ppp": 42.8460510517715,
    "pppYear": 2025,
    "fx": 131.605925,
    "fxYear": 2025
  },
  "EA": {
    "name": "Ceuta & Melilla",
    "iso3": "",
    "currency": "eur",
    "incomeLevel": "HIC",
    "ppp": 0.570991,
    "pppYear": 2025,
    "fx": 0.88496895841236,
    "fxYear": 2025,
    "pricingDataType": "territory_proxy",
    "pricingProxyCountryCode": "ES",
    "pricingCurrencyMultiplier": 1
  },
  "EC": {
    "name": "Ecuador",
    "iso3": "ECU",
    "currency": "usd",
    "incomeLevel": "UMC",
    "ppp": 0.425220703426529,
    "pppYear": 2025,
    "fx": 1,
    "fxYear": 2025
  },
  "EE": {
    "name": "Estonia",
    "iso3": "EST",
    "currency": "eur",
    "incomeLevel": "HIC",
    "ppp": 0.584555,
    "pppYear": 2025,
    "fx": 0.88496895841236,
    "fxYear": 2025
  },
  "EG": {
    "name": "Egypt, Arab Rep.",
    "iso3": "EGY",
    "currency": "egp",
    "incomeLevel": "LMC",
    "ppp": 7.58370974796763,
    "pppYear": 2025,
    "fx": 49.2277558333333,
    "fxYear": 2025
  },
  "EH": {
    "name": "Western Sahara",
    "iso3": "",
    "currency": "mad",
    "incomeLevel": "LMC",
    "ppp": 3.93179684727296,
    "pppYear": 2025,
    "fx": 9.35027697089947,
    "fxYear": 2025,
    "pricingDataType": "territory_proxy",
    "pricingProxyCountryCode": "MA",
    "pricingCurrencyMultiplier": 1
  },
  "ER": {
    "name": "Eritrea",
    "iso3": "ERI",
    "currency": "ern",
    "incomeLevel": "LIC",
    "ppp": 4.93847894668579,
    "pppYear": 2021,
    "fx": 15.075,
    "fxYear": 2025
  },
  "ES": {
    "name": "Spain",
    "iso3": "ESP",
    "currency": "eur",
    "incomeLevel": "HIC",
    "ppp": 0.570991,
    "pppYear": 2025,
    "fx": 0.88496895841236,
    "fxYear": 2025
  },
  "ET": {
    "name": "Ethiopia",
    "iso3": "ETH",
    "currency": "etb",
    "incomeLevel": "LIC",
    "ppp": 30.7650224136466,
    "pppYear": 2025,
    "fx": 82.6013363504764,
    "fxYear": 2024
  },
  "EU": {
    "name": "European Union",
    "iso3": "",
    "currency": "eur",
    "incomeLevel": "HIC",
    "ppp": 0.709983,
    "pppYear": 2025,
    "fx": 0.88496895841236,
    "fxYear": 2025,
    "pricingDataType": "territory_proxy",
    "pricingProxyCountryCode": "DE",
    "pricingCurrencyMultiplier": 1
  },
  "FI": {
    "name": "Finland",
    "iso3": "FIN",
    "currency": "eur",
    "incomeLevel": "HIC",
    "ppp": 0.754195,
    "pppYear": 2025,
    "fx": 0.88496895841236,
    "fxYear": 2025
  },
  "FJ": {
    "name": "Fiji",
    "iso3": "FJI",
    "currency": "fjd",
    "incomeLevel": "UMC",
    "ppp": 0.934666867351328,
    "pppYear": 2025,
    "fx": 2.29903333333333,
    "fxYear": 2025
  },
  "FK": {
    "name": "Falkland Islands",
    "iso3": "",
    "currency": "fkp",
    "incomeLevel": "HIC",
    "ppp": 0.677133,
    "pppYear": 2025,
    "fx": 0.759473957338608,
    "fxYear": 2025,
    "pricingDataType": "territory_proxy",
    "pricingProxyCountryCode": "GB",
    "pricingCurrencyMultiplier": 1
  },
  "FM": {
    "name": "Micronesia, Fed. Sts.",
    "iso3": "FSM",
    "currency": "usd",
    "incomeLevel": "UMC",
    "ppp": 0.95865080658499,
    "pppYear": 2025,
    "fx": 1,
    "fxYear": 2025
  },
  "FO": {
    "name": "Faroe Islands",
    "iso3": "FRO",
    "currency": "dkk",
    "incomeLevel": "HIC",
    "ppp": 6.22980312304618,
    "pppYear": 2024,
    "fx": 6.62182508333333,
    "fxYear": 2025
  },
  "FR": {
    "name": "France",
    "iso3": "FRA",
    "currency": "eur",
    "incomeLevel": "HIC",
    "ppp": 0.677618,
    "pppYear": 2025,
    "fx": 0.88496895841236,
    "fxYear": 2025
  },
  "GA": {
    "name": "Gabon",
    "iso3": "GAB",
    "currency": "xaf",
    "incomeLevel": "UMC",
    "ppp": 216.420044727798,
    "pppYear": 2025,
    "fx": 581.92848104034,
    "fxYear": 2025
  },
  "GB": {
    "name": "United Kingdom",
    "iso3": "GBR",
    "currency": "gbp",
    "incomeLevel": "HIC",
    "ppp": 0.677133,
    "pppYear": 2025,
    "fx": 0.759473957338608,
    "fxYear": 2025
  },
  "GD": {
    "name": "Grenada",
    "iso3": "GRD",
    "currency": "xcd",
    "incomeLevel": "UMC",
    "ppp": 1.53137011170231,
    "pppYear": 2025,
    "fx": 2.7,
    "fxYear": 2025
  },
  "GE": {
    "name": "Georgia",
    "iso3": "GEO",
    "currency": "gel",
    "incomeLevel": "UMC",
    "ppp": 0.903514180711349,
    "pppYear": 2025,
    "fx": 2.74264166666667,
    "fxYear": 2025
  },
  "GF": {
    "name": "French Guiana",
    "iso3": "",
    "currency": "eur",
    "incomeLevel": "HIC",
    "ppp": 0.677618,
    "pppYear": 2025,
    "fx": 0.88496895841236,
    "fxYear": 2025,
    "pricingDataType": "territory_proxy",
    "pricingProxyCountryCode": "FR",
    "pricingCurrencyMultiplier": 1
  },
  "GG": {
    "name": "Guernsey",
    "iso3": "",
    "currency": "gbp",
    "incomeLevel": "HIC",
    "ppp": 0.677133,
    "pppYear": 2025,
    "fx": 0.759473957338608,
    "fxYear": 2025,
    "pricingDataType": "territory_proxy",
    "pricingProxyCountryCode": "GB",
    "pricingCurrencyMultiplier": 1
  },
  "GH": {
    "name": "Ghana",
    "iso3": "GHA",
    "currency": "ghs",
    "incomeLevel": "LMC",
    "ppp": 4.75008975177416,
    "pppYear": 2025,
    "fx": 12.556825,
    "fxYear": 2025
  },
  "GI": {
    "name": "Gibraltar",
    "iso3": "GIB",
    "currency": "gip",
    "incomeLevel": "HIC",
    "ppp": null,
    "pppYear": null,
    "fx": 0.759473957338608,
    "fxYear": 2025
  },
  "GL": {
    "name": "Greenland",
    "iso3": "GRL",
    "currency": "dkk",
    "incomeLevel": "HIC",
    "ppp": 5.10788380262313,
    "pppYear": 2023,
    "fx": 6.62182508333333,
    "fxYear": 2025
  },
  "GM": {
    "name": "Gambia, The",
    "iso3": "GMB",
    "currency": "gmd",
    "incomeLevel": "LIC",
    "ppp": 17.7935316169312,
    "pppYear": 2025,
    "fx": 71.2893818242692,
    "fxYear": 2025
  },
  "GN": {
    "name": "Guinea",
    "iso3": "GIN",
    "currency": "gnf",
    "incomeLevel": "LMC",
    "ppp": 3286.09262410062,
    "pppYear": 2025,
    "fx": 9565.08218343833,
    "fxYear": 2020
  },
  "GP": {
    "name": "Guadeloupe",
    "iso3": "",
    "currency": "eur",
    "incomeLevel": "HIC",
    "ppp": 0.677618,
    "pppYear": 2025,
    "fx": 0.88496895841236,
    "fxYear": 2025,
    "pricingDataType": "territory_proxy",
    "pricingProxyCountryCode": "FR",
    "pricingCurrencyMultiplier": 1
  },
  "GQ": {
    "name": "Equatorial Guinea",
    "iso3": "GNQ",
    "currency": "xaf",
    "incomeLevel": "UMC",
    "ppp": 238.615174467719,
    "pppYear": 2025,
    "fx": 581.92848104034,
    "fxYear": 2025
  },
  "GR": {
    "name": "Greece",
    "iso3": "GRC",
    "currency": "eur",
    "incomeLevel": "HIC",
    "ppp": 0.526872,
    "pppYear": 2025,
    "fx": 0.88496895841236,
    "fxYear": 2025
  },
  "GS": {
    "name": "South Georgia & South Sandwich Islands",
    "iso3": "",
    "currency": "gbp",
    "incomeLevel": "HIC",
    "ppp": 0.677133,
    "pppYear": 2025,
    "fx": 0.759473957338608,
    "fxYear": 2025,
    "pricingDataType": "territory_proxy",
    "pricingProxyCountryCode": "GB",
    "pricingCurrencyMultiplier": 1
  },
  "GT": {
    "name": "Guatemala",
    "iso3": "GTM",
    "currency": "gtq",
    "incomeLevel": "UMC",
    "ppp": 3.33451157924276,
    "pppYear": 2025,
    "fx": 7.68012458333333,
    "fxYear": 2025
  },
  "GU": {
    "name": "Guam",
    "iso3": "GUM",
    "currency": "usd",
    "incomeLevel": "HIC",
    "ppp": null,
    "pppYear": null,
    "fx": 1,
    "fxYear": 2025
  },
  "GW": {
    "name": "Guinea-Bissau",
    "iso3": "GNB",
    "currency": "xof",
    "incomeLevel": "LIC",
    "ppp": 198.582744438309,
    "pppYear": 2025,
    "fx": 581.92848104034,
    "fxYear": 2025
  },
  "GY": {
    "name": "Guyana",
    "iso3": "GUY",
    "currency": "gyd",
    "incomeLevel": "HIC",
    "ppp": 69.0331367456556,
    "pppYear": 2025,
    "fx": 208.5,
    "fxYear": 2025
  },
  "HK": {
    "name": "Hong Kong SAR, China",
    "iso3": "HKG",
    "currency": "hkd",
    "incomeLevel": "HIC",
    "ppp": 5.52457295433365,
    "pppYear": 2025,
    "fx": 7.79708333333333,
    "fxYear": 2025
  },
  "HM": {
    "name": "Heard & McDonald Islands",
    "iso3": "",
    "currency": "aud",
    "incomeLevel": "HIC",
    "ppp": 1.398943,
    "pppYear": 2025,
    "fx": 1.5519978866485,
    "fxYear": 2025,
    "pricingDataType": "territory_proxy",
    "pricingProxyCountryCode": "AU",
    "pricingCurrencyMultiplier": 1
  },
  "HN": {
    "name": "Honduras",
    "iso3": "HND",
    "currency": "hnl",
    "incomeLevel": "LMC",
    "ppp": 11.8640844280338,
    "pppYear": 2025,
    "fx": 25.9526748179551,
    "fxYear": 2025
  },
  "HR": {
    "name": "Croatia",
    "iso3": "HRV",
    "currency": "eur",
    "incomeLevel": "HIC",
    "ppp": 0.470813052018898,
    "pppYear": 2025,
    "fx": 0.88496895841236,
    "fxYear": 2025
  },
  "HT": {
    "name": "Haiti",
    "iso3": "HTI",
    "currency": "htg",
    "incomeLevel": "LMC",
    "ppp": 112.359715746475,
    "pppYear": 2025,
    "fx": 130.626409210526,
    "fxYear": 2025
  },
  "HU": {
    "name": "Hungary",
    "iso3": "HUN",
    "currency": "huf",
    "incomeLevel": "HIC",
    "ppp": 183.57556,
    "pppYear": 2025,
    "fx": 353.14,
    "fxYear": 2025
  },
  "IC": {
    "name": "Canary Islands",
    "iso3": "",
    "currency": "eur",
    "incomeLevel": "HIC",
    "ppp": 0.570991,
    "pppYear": 2025,
    "fx": 0.88496895841236,
    "fxYear": 2025,
    "pricingDataType": "territory_proxy",
    "pricingProxyCountryCode": "ES",
    "pricingCurrencyMultiplier": 1
  },
  "ID": {
    "name": "Indonesia",
    "iso3": "IDN",
    "currency": "idr",
    "incomeLevel": "UMC",
    "ppp": 4720.99750025346,
    "pppYear": 2025,
    "fx": 16477.8651797836,
    "fxYear": 2025
  },
  "IE": {
    "name": "Ireland",
    "iso3": "IRL",
    "currency": "eur",
    "incomeLevel": "HIC",
    "ppp": 0.750891,
    "pppYear": 2025,
    "fx": 0.88496895841236,
    "fxYear": 2025
  },
  "IL": {
    "name": "Israel",
    "iso3": "ISR",
    "currency": "ils",
    "incomeLevel": "HIC",
    "ppp": 3.487723,
    "pppYear": 2025,
    "fx": 3.45189166666667,
    "fxYear": 2025
  },
  "IM": {
    "name": "Isle of Man",
    "iso3": "IMN",
    "currency": "gbp",
    "incomeLevel": "HIC",
    "ppp": null,
    "pppYear": null,
    "fx": 0.759473957338608,
    "fxYear": 2025
  },
  "IN": {
    "name": "India",
    "iso3": "IND",
    "currency": "inr",
    "incomeLevel": "LMC",
    "ppp": 20.0886288014602,
    "pppYear": 2025,
    "fx": 87.1584483507393,
    "fxYear": 2025
  },
  "IO": {
    "name": "British Indian Ocean Territory",
    "iso3": "",
    "currency": "usd",
    "incomeLevel": "HIC",
    "ppp": 1,
    "pppYear": 2025,
    "fx": 1,
    "fxYear": 2025,
    "pricingDataType": "territory_proxy",
    "pricingProxyCountryCode": "US",
    "pricingCurrencyMultiplier": 1
  },
  "IQ": {
    "name": "Iraq",
    "iso3": "IRQ",
    "currency": "iqd",
    "incomeLevel": "UMC",
    "ppp": 492.933552332882,
    "pppYear": 2025,
    "fx": 1300,
    "fxYear": 2024
  },
  "IR": {
    "name": "Iran, Islamic Rep.",
    "iso3": "IRN",
    "currency": "irr",
    "incomeLevel": "UMC",
    "ppp": 147937.809998602,
    "pppYear": 2025,
    "fx": 42000,
    "fxYear": 2023
  },
  "IS": {
    "name": "Iceland",
    "iso3": "ISL",
    "currency": "isk",
    "incomeLevel": "HIC",
    "ppp": 151.367985,
    "pppYear": 2025,
    "fx": 128.441487054951,
    "fxYear": 2025
  },
  "IT": {
    "name": "Italy",
    "iso3": "ITA",
    "currency": "eur",
    "incomeLevel": "HIC",
    "ppp": 0.610275,
    "pppYear": 2025,
    "fx": 0.88496895841236,
    "fxYear": 2025
  },
  "JE": {
    "name": "Jersey",
    "iso3": "",
    "currency": "gbp",
    "incomeLevel": "HIC",
    "ppp": 0.677133,
    "pppYear": 2025,
    "fx": 0.759473957338608,
    "fxYear": 2025,
    "pricingDataType": "territory_proxy",
    "pricingProxyCountryCode": "GB",
    "pricingCurrencyMultiplier": 1
  },
  "JG": {
    "name": "Channel Islands",
    "iso3": "CHI",
    "currency": "usd",
    "incomeLevel": "HIC",
    "ppp": null,
    "pppYear": null,
    "fx": 0.759473957338607,
    "fxYear": 2025
  },
  "JM": {
    "name": "Jamaica",
    "iso3": "JAM",
    "currency": "jmd",
    "incomeLevel": "UMC",
    "ppp": 95.7950373528488,
    "pppYear": 2025,
    "fx": 159.096428305753,
    "fxYear": 2025
  },
  "JO": {
    "name": "Jordan",
    "iso3": "JOR",
    "currency": "jod",
    "incomeLevel": "UMC",
    "ppp": 0.300588436411238,
    "pppYear": 2025,
    "fx": 0.71,
    "fxYear": 2025
  },
  "JP": {
    "name": "Japan",
    "iso3": "JPN",
    "currency": "jpy",
    "incomeLevel": "HIC",
    "ppp": 97.08005,
    "pppYear": 2025,
    "fx": 149.657926890952,
    "fxYear": 2025
  },
  "KE": {
    "name": "Kenya",
    "iso3": "KEN",
    "currency": "kes",
    "incomeLevel": "LMC",
    "ppp": 43.5471478663385,
    "pppYear": 2025,
    "fx": 129.302572099377,
    "fxYear": 2025
  },
  "KG": {
    "name": "Kyrgyz Republic",
    "iso3": "KGZ",
    "currency": "kgs",
    "incomeLevel": "LMC",
    "ppp": 29.1935664341276,
    "pppYear": 2025,
    "fx": 87.1503126405883,
    "fxYear": 2024
  },
  "KH": {
    "name": "Cambodia",
    "iso3": "KHM",
    "currency": "khr",
    "incomeLevel": "LMC",
    "ppp": 1349.49224235827,
    "pppYear": 2025,
    "fx": 4013.43310400666,
    "fxYear": 2025
  },
  "KI": {
    "name": "Kiribati",
    "iso3": "KIR",
    "currency": "aud",
    "incomeLevel": "LMC",
    "ppp": 1.00874671689262,
    "pppYear": 2025,
    "fx": 1.5519978866485,
    "fxYear": 2025
  },
  "KM": {
    "name": "Comoros",
    "iso3": "COM",
    "currency": "kmf",
    "incomeLevel": "LMC",
    "ppp": 211.662236779844,
    "pppYear": 2025,
    "fx": 435.376187289973,
    "fxYear": 2025
  },
  "KN": {
    "name": "St. Kitts and Nevis",
    "iso3": "KNA",
    "currency": "xcd",
    "incomeLevel": "HIC",
    "ppp": 1.85174655680503,
    "pppYear": 2025,
    "fx": 2.7,
    "fxYear": 2025
  },
  "KP": {
    "name": "Korea, Dem. People's Rep.",
    "iso3": "PRK",
    "currency": "kpw",
    "incomeLevel": "LIC",
    "ppp": null,
    "pppYear": null,
    "fx": null,
    "fxYear": null
  },
  "KR": {
    "name": "Korea, Rep.",
    "iso3": "KOR",
    "currency": "krw",
    "incomeLevel": "HIC",
    "ppp": 816.329274,
    "pppYear": 2025,
    "fx": 1422.44083333333,
    "fxYear": 2025
  },
  "KW": {
    "name": "Kuwait",
    "iso3": "KWT",
    "currency": "kwd",
    "incomeLevel": "HIC",
    "ppp": 0.175361574871678,
    "pppYear": 2025,
    "fx": 0.306454776364578,
    "fxYear": 2025
  },
  "KY": {
    "name": "Cayman Islands",
    "iso3": "CYM",
    "currency": "kyd",
    "incomeLevel": "HIC",
    "ppp": 0.94261799236714,
    "pppYear": 2024,
    "fx": 0.83333,
    "fxYear": 2025
  },
  "KZ": {
    "name": "Kazakhstan",
    "iso3": "KAZ",
    "currency": "kzt",
    "incomeLevel": "UMC",
    "ppp": 172.827127700445,
    "pppYear": 2025,
    "fx": 521.035,
    "fxYear": 2025
  },
  "LA": {
    "name": "Lao PDR",
    "iso3": "LAO",
    "currency": "lak",
    "incomeLevel": "LMC",
    "ppp": 4577.46196269632,
    "pppYear": 2025,
    "fx": 20167.3313803145,
    "fxYear": 2024
  },
  "LB": {
    "name": "Lebanon",
    "iso3": "LBN",
    "currency": "lbp",
    "incomeLevel": "LMC",
    "ppp": 33594.2483818204,
    "pppYear": 2024,
    "fx": 89500,
    "fxYear": 2025
  },
  "LC": {
    "name": "St. Lucia",
    "iso3": "LCA",
    "currency": "xcd",
    "incomeLevel": "UMC",
    "ppp": 1.38850270829587,
    "pppYear": 2025,
    "fx": 2.7,
    "fxYear": 2025
  },
  "LI": {
    "name": "Liechtenstein",
    "iso3": "LIE",
    "currency": "chf",
    "incomeLevel": "HIC",
    "ppp": null,
    "pppYear": null,
    "fx": 0.831355833333333,
    "fxYear": 2025
  },
  "LK": {
    "name": "Sri Lanka",
    "iso3": "LKA",
    "currency": "lkr",
    "incomeLevel": "UMC",
    "ppp": 88.2137716979226,
    "pppYear": 2025,
    "fx": 327.506533333333,
    "fxYear": 2023
  },
  "LR": {
    "name": "Liberia",
    "iso3": "LBR",
    "currency": "lrd",
    "incomeLevel": "LIC",
    "ppp": 0.462031881161655,
    "pppYear": 2025,
    "fx": 191.306666666667,
    "fxYear": 2024
  },
  "LS": {
    "name": "Lesotho",
    "iso3": "LSO",
    "currency": "zar",
    "incomeLevel": "LMC",
    "ppp": 6.11792216885233,
    "pppYear": 2025,
    "fx": 17.8887489855833,
    "fxYear": 2025
  },
  "LT": {
    "name": "Lithuania",
    "iso3": "LTU",
    "currency": "eur",
    "incomeLevel": "HIC",
    "ppp": 0.513169,
    "pppYear": 2025,
    "fx": 0.88496895841236,
    "fxYear": 2025
  },
  "LU": {
    "name": "Luxembourg",
    "iso3": "LUX",
    "currency": "eur",
    "incomeLevel": "HIC",
    "ppp": 0.832451,
    "pppYear": 2025,
    "fx": 0.88496895841236,
    "fxYear": 2025
  },
  "LV": {
    "name": "Latvia",
    "iso3": "LVA",
    "currency": "eur",
    "incomeLevel": "HIC",
    "ppp": 0.504702,
    "pppYear": 2025,
    "fx": 0.88496895841236,
    "fxYear": 2025
  },
  "LY": {
    "name": "Libya",
    "iso3": "LBY",
    "currency": "lyd",
    "incomeLevel": "UMC",
    "ppp": 2.07074496071786,
    "pppYear": 2025,
    "fx": 5.30256666666666,
    "fxYear": 2025
  },
  "MA": {
    "name": "Morocco",
    "iso3": "MAR",
    "currency": "mad",
    "incomeLevel": "LMC",
    "ppp": 3.93179684727296,
    "pppYear": 2025,
    "fx": 9.35027697089947,
    "fxYear": 2025
  },
  "MC": {
    "name": "Monaco",
    "iso3": "MCO",
    "currency": "eur",
    "incomeLevel": "HIC",
    "ppp": null,
    "pppYear": null,
    "fx": 0.88496895841236,
    "fxYear": 2025
  },
  "MD": {
    "name": "Moldova",
    "iso3": "MDA",
    "currency": "mdl",
    "incomeLevel": "UMC",
    "ppp": 7.48976511532315,
    "pppYear": 2025,
    "fx": 17.3778474404762,
    "fxYear": 2025
  },
  "ME": {
    "name": "Montenegro",
    "iso3": "MNE",
    "currency": "eur",
    "incomeLevel": "UMC",
    "ppp": 0.370171163809184,
    "pppYear": 2025,
    "fx": 0.887144250370588,
    "fxYear": 2025
  },
  "MF": {
    "name": "St. Martin (French part)",
    "iso3": "MAF",
    "currency": "eur",
    "incomeLevel": "HIC",
    "ppp": null,
    "pppYear": null,
    "fx": 0.88496895841236,
    "fxYear": 2025
  },
  "MG": {
    "name": "Madagascar",
    "iso3": "MDG",
    "currency": "mga",
    "incomeLevel": "LIC",
    "ppp": 1390.29172218468,
    "pppYear": 2025,
    "fx": 4529.75125196405,
    "fxYear": 2025
  },
  "MH": {
    "name": "Marshall Islands",
    "iso3": "MHL",
    "currency": "usd",
    "incomeLevel": "UMC",
    "ppp": 0.946982695755452,
    "pppYear": 2025,
    "fx": 1,
    "fxYear": 2025
  },
  "MK": {
    "name": "North Macedonia",
    "iso3": "MKD",
    "currency": "mkd",
    "incomeLevel": "UMC",
    "ppp": 20.453219828119,
    "pppYear": 2025,
    "fx": 54.6549666666667,
    "fxYear": 2025
  },
  "ML": {
    "name": "Mali",
    "iso3": "MLI",
    "currency": "xof",
    "incomeLevel": "LIC",
    "ppp": 198.243965775836,
    "pppYear": 2025,
    "fx": 581.92848104034,
    "fxYear": 2025
  },
  "MM": {
    "name": "Myanmar",
    "iso3": "MMR",
    "currency": "mmk",
    "incomeLevel": "LMC",
    "ppp": 520.106449561224,
    "pppYear": 2025,
    "fx": 1381.61916666667,
    "fxYear": 2020
  },
  "MN": {
    "name": "Mongolia",
    "iso3": "MNG",
    "currency": "mnt",
    "incomeLevel": "UMC",
    "ppp": 1211.65358016366,
    "pppYear": 2025,
    "fx": 3545.14356555046,
    "fxYear": 2025
  },
  "MO": {
    "name": "Macao SAR, China",
    "iso3": "MAC",
    "currency": "mop",
    "incomeLevel": "HIC",
    "ppp": 4.44773830276597,
    "pppYear": 2025,
    "fx": 8.02981025,
    "fxYear": 2025
  },
  "MP": {
    "name": "Northern Mariana Islands",
    "iso3": "MNP",
    "currency": "usd",
    "incomeLevel": "HIC",
    "ppp": null,
    "pppYear": null,
    "fx": 1,
    "fxYear": 2025
  },
  "MQ": {
    "name": "Martinique",
    "iso3": "",
    "currency": "eur",
    "incomeLevel": "HIC",
    "ppp": 0.677618,
    "pppYear": 2025,
    "fx": 0.88496895841236,
    "fxYear": 2025,
    "pricingDataType": "territory_proxy",
    "pricingProxyCountryCode": "FR",
    "pricingCurrencyMultiplier": 1
  },
  "MR": {
    "name": "Mauritania",
    "iso3": "MRT",
    "currency": "mru",
    "incomeLevel": "LMC",
    "ppp": 11.391685569891,
    "pppYear": 2025,
    "fx": 36.4891666666666,
    "fxYear": 2023
  },
  "MS": {
    "name": "Montserrat",
    "iso3": "",
    "currency": "xcd",
    "incomeLevel": "HIC",
    "ppp": 1.87014584555665,
    "pppYear": 2025,
    "fx": 2.7,
    "fxYear": 2025,
    "pricingDataType": "territory_proxy",
    "pricingProxyCountryCode": "AG",
    "pricingCurrencyMultiplier": 1
  },
  "MT": {
    "name": "Malta",
    "iso3": "MLT",
    "currency": "eur",
    "incomeLevel": "HIC",
    "ppp": 0.58711979275282,
    "pppYear": 2025,
    "fx": 0.88496895841236,
    "fxYear": 2025
  },
  "MU": {
    "name": "Mauritius",
    "iso3": "MUS",
    "currency": "mur",
    "incomeLevel": "UMC",
    "ppp": 17.7493221711606,
    "pppYear": 2025,
    "fx": 45.9969666666667,
    "fxYear": 2025
  },
  "MV": {
    "name": "Maldives",
    "iso3": "MDV",
    "currency": "mvr",
    "incomeLevel": "UMC",
    "ppp": 7.88991987219358,
    "pppYear": 2025,
    "fx": 15.415677547363,
    "fxYear": 2025
  },
  "MW": {
    "name": "Malawi",
    "iso3": "MWI",
    "currency": "mwk",
    "incomeLevel": "LIC",
    "ppp": 619.005548775964,
    "pppYear": 2025,
    "fx": 1161.09436666667,
    "fxYear": 2023
  },
  "MX": {
    "name": "Mexico",
    "iso3": "MEX",
    "currency": "mxn",
    "incomeLevel": "UMC",
    "ppp": 10.328951,
    "pppYear": 2025,
    "fx": 19.2375083333333,
    "fxYear": 2025
  },
  "MY": {
    "name": "Malaysia",
    "iso3": "MYS",
    "currency": "myr",
    "incomeLevel": "UMC",
    "ppp": 1.35504364404393,
    "pppYear": 2025,
    "fx": 4.28442415048243,
    "fxYear": 2025
  },
  "MZ": {
    "name": "Mozambique",
    "iso3": "MOZ",
    "currency": "mzn",
    "incomeLevel": "LIC",
    "ppp": 23.6620035302763,
    "pppYear": 2025,
    "fx": 63.905,
    "fxYear": 2024
  },
  "NA": {
    "name": "Namibia",
    "iso3": "NAM",
    "currency": "zar",
    "incomeLevel": "LMC",
    "ppp": 7.27733758379859,
    "pppYear": 2025,
    "fx": 17.8887333333333,
    "fxYear": 2025
  },
  "NC": {
    "name": "New Caledonia",
    "iso3": "NCL",
    "currency": "xpf",
    "incomeLevel": "HIC",
    "ppp": null,
    "pppYear": null,
    "fx": 105.864431541948,
    "fxYear": 2025
  },
  "NE": {
    "name": "Niger",
    "iso3": "NER",
    "currency": "xof",
    "incomeLevel": "LIC",
    "ppp": 207.234045559658,
    "pppYear": 2025,
    "fx": 581.92848104034,
    "fxYear": 2025
  },
  "NF": {
    "name": "Norfolk Island",
    "iso3": "",
    "currency": "aud",
    "incomeLevel": "HIC",
    "ppp": 1.398943,
    "pppYear": 2025,
    "fx": 1.5519978866485,
    "fxYear": 2025,
    "pricingDataType": "territory_proxy",
    "pricingProxyCountryCode": "AU",
    "pricingCurrencyMultiplier": 1
  },
  "NG": {
    "name": "Nigeria",
    "iso3": "NGA",
    "currency": "ngn",
    "incomeLevel": "LMC",
    "ppp": 195.022548515709,
    "pppYear": 2025,
    "fx": 1518.38094813368,
    "fxYear": 2025
  },
  "NI": {
    "name": "Nicaragua",
    "iso3": "NIC",
    "currency": "nio",
    "incomeLevel": "LMC",
    "ppp": 12.5185500987327,
    "pppYear": 2025,
    "fx": 36.6243,
    "fxYear": 2025
  },
  "NL": {
    "name": "Netherlands",
    "iso3": "NLD",
    "currency": "eur",
    "incomeLevel": "HIC",
    "ppp": 0.746769,
    "pppYear": 2025,
    "fx": 0.88496895841236,
    "fxYear": 2025
  },
  "NO": {
    "name": "Norway",
    "iso3": "NOR",
    "currency": "nok",
    "incomeLevel": "HIC",
    "ppp": 9.451661,
    "pppYear": 2025,
    "fx": 10.3958333333333,
    "fxYear": 2025
  },
  "NP": {
    "name": "Nepal",
    "iso3": "NPL",
    "currency": "npr",
    "incomeLevel": "LMC",
    "ppp": 33.8982001034302,
    "pppYear": 2025,
    "fx": 139.115437592696,
    "fxYear": 2025
  },
  "NR": {
    "name": "Naoero",
    "iso3": "NRU",
    "currency": "aud",
    "incomeLevel": "HIC",
    "ppp": 1.59287093272538,
    "pppYear": 2025,
    "fx": 1.5519978866485,
    "fxYear": 2025
  },
  "NU": {
    "name": "Niue",
    "iso3": "",
    "currency": "nzd",
    "incomeLevel": "HIC",
    "ppp": 1.472957,
    "pppYear": 2025,
    "fx": 1.72010833333333,
    "fxYear": 2025,
    "pricingDataType": "territory_proxy",
    "pricingProxyCountryCode": "NZ",
    "pricingCurrencyMultiplier": 1
  },
  "NZ": {
    "name": "New Zealand",
    "iso3": "NZL",
    "currency": "nzd",
    "incomeLevel": "HIC",
    "ppp": 1.472957,
    "pppYear": 2025,
    "fx": 1.72010833333333,
    "fxYear": 2025
  },
  "OM": {
    "name": "Oman",
    "iso3": "OMN",
    "currency": "omr",
    "incomeLevel": "HIC",
    "ppp": 0.181339214175172,
    "pppYear": 2025,
    "fx": 0.3845,
    "fxYear": 2025
  },
  "PA": {
    "name": "Panama",
    "iso3": "PAN",
    "currency": "pab",
    "incomeLevel": "HIC",
    "ppp": 0.45076892365416,
    "pppYear": 2025,
    "fx": 1,
    "fxYear": 2025
  },
  "PE": {
    "name": "Peru",
    "iso3": "PER",
    "currency": "pen",
    "incomeLevel": "UMC",
    "ppp": 1.83592285276037,
    "pppYear": 2025,
    "fx": 3.5670638032991,
    "fxYear": 2025
  },
  "PF": {
    "name": "French Polynesia",
    "iso3": "PYF",
    "currency": "xpf",
    "incomeLevel": "HIC",
    "ppp": null,
    "pppYear": null,
    "fx": 105.864431541948,
    "fxYear": 2025
  },
  "PG": {
    "name": "Papua New Guinea",
    "iso3": "PNG",
    "currency": "pgk",
    "incomeLevel": "LMC",
    "ppp": 2.38719956855142,
    "pppYear": 2025,
    "fx": 4.12272372720281,
    "fxYear": 2025
  },
  "PH": {
    "name": "Philippines",
    "iso3": "PHL",
    "currency": "php",
    "incomeLevel": "UMC",
    "ppp": 19.069580238078,
    "pppYear": 2025,
    "fx": 57.5050971489715,
    "fxYear": 2025
  },
  "PK": {
    "name": "Pakistan",
    "iso3": "PAK",
    "currency": "pkr",
    "incomeLevel": "LMC",
    "ppp": 67.8368115155746,
    "pppYear": 2025,
    "fx": 281.143001173202,
    "fxYear": 2025
  },
  "PL": {
    "name": "Poland",
    "iso3": "POL",
    "currency": "pln",
    "incomeLevel": "HIC",
    "ppp": 1.969559,
    "pppYear": 2025,
    "fx": 3.76054166666667,
    "fxYear": 2025
  },
  "PM": {
    "name": "St. Pierre & Miquelon",
    "iso3": "",
    "currency": "eur",
    "incomeLevel": "HIC",
    "ppp": 0.677618,
    "pppYear": 2025,
    "fx": 0.88496895841236,
    "fxYear": 2025,
    "pricingDataType": "territory_proxy",
    "pricingProxyCountryCode": "FR",
    "pricingCurrencyMultiplier": 1
  },
  "PN": {
    "name": "Pitcairn Islands",
    "iso3": "",
    "currency": "nzd",
    "incomeLevel": "HIC",
    "ppp": 1.472957,
    "pppYear": 2025,
    "fx": 1.72010833333333,
    "fxYear": 2025,
    "pricingDataType": "territory_proxy",
    "pricingProxyCountryCode": "NZ",
    "pricingCurrencyMultiplier": 1
  },
  "PR": {
    "name": "Puerto Rico (US)",
    "iso3": "PRI",
    "currency": "usd",
    "incomeLevel": "HIC",
    "ppp": 0.778230137047568,
    "pppYear": 2025,
    "fx": 1,
    "fxYear": 2025
  },
  "PS": {
    "name": "West Bank and Gaza",
    "iso3": "PSE",
    "currency": "ils",
    "incomeLevel": "LMC",
    "ppp": 0.63425809329856,
    "pppYear": 2025,
    "fx": null,
    "fxYear": null
  },
  "PT": {
    "name": "Portugal",
    "iso3": "PRT",
    "currency": "eur",
    "incomeLevel": "HIC",
    "ppp": 0.534218,
    "pppYear": 2025,
    "fx": 0.88496895841236,
    "fxYear": 2025
  },
  "PW": {
    "name": "Palau",
    "iso3": "PLW",
    "currency": "usd",
    "incomeLevel": "HIC",
    "ppp": 0.847328995677767,
    "pppYear": 2025,
    "fx": 1,
    "fxYear": 2025
  },
  "PY": {
    "name": "Paraguay",
    "iso3": "PRY",
    "currency": "pyg",
    "incomeLevel": "UMC",
    "ppp": 2627.11785121353,
    "pppYear": 2025,
    "fx": 7545.44675537411,
    "fxYear": 2025
  },
  "QA": {
    "name": "Qatar",
    "iso3": "QAT",
    "currency": "qar",
    "incomeLevel": "HIC",
    "ppp": 2.0482980288714,
    "pppYear": 2025,
    "fx": 3.64,
    "fxYear": 2025
  },
  "RE": {
    "name": "Réunion",
    "iso3": "",
    "currency": "eur",
    "incomeLevel": "HIC",
    "ppp": 0.677618,
    "pppYear": 2025,
    "fx": 0.88496895841236,
    "fxYear": 2025,
    "pricingDataType": "territory_proxy",
    "pricingProxyCountryCode": "FR",
    "pricingCurrencyMultiplier": 1
  },
  "RO": {
    "name": "Romania",
    "iso3": "ROU",
    "currency": "ron",
    "incomeLevel": "HIC",
    "ppp": 1.97967891250975,
    "pppYear": 2025,
    "fx": 4.47053333333333,
    "fxYear": 2025
  },
  "RS": {
    "name": "Serbia",
    "iso3": "SRB",
    "currency": "rsd",
    "incomeLevel": "UMC",
    "ppp": 46.7970682889855,
    "pppYear": 2025,
    "fx": 103.9754,
    "fxYear": 2025
  },
  "RU": {
    "name": "Russian Federation",
    "iso3": "RUS",
    "currency": "rub",
    "incomeLevel": "HIC",
    "ppp": 29.6122633846497,
    "pppYear": 2025,
    "fx": 92.5524,
    "fxYear": 2024
  },
  "RW": {
    "name": "Rwanda",
    "iso3": "RWA",
    "currency": "rwf",
    "incomeLevel": "LIC",
    "ppp": 385.463038224109,
    "pppYear": 2025,
    "fx": 1428.47827558333,
    "fxYear": 2025
  },
  "SA": {
    "name": "Saudi Arabia",
    "iso3": "SAU",
    "currency": "sar",
    "incomeLevel": "HIC",
    "ppp": 1.75530234452142,
    "pppYear": 2025,
    "fx": 3.75,
    "fxYear": 2025
  },
  "SB": {
    "name": "Solomon Islands",
    "iso3": "SLB",
    "currency": "sbd",
    "incomeLevel": "LMC",
    "ppp": 6.23162133063873,
    "pppYear": 2025,
    "fx": 8.32684233252033,
    "fxYear": 2025
  },
  "SC": {
    "name": "Seychelles",
    "iso3": "SYC",
    "currency": "scr",
    "incomeLevel": "HIC",
    "ppp": 7.98797394952878,
    "pppYear": 2025,
    "fx": 14.7254562696937,
    "fxYear": 2025
  },
  "SD": {
    "name": "Sudan",
    "iso3": "SDN",
    "currency": "sdg",
    "incomeLevel": "LIC",
    "ppp": 1175.58773572252,
    "pppYear": 2025,
    "fx": 546.75885,
    "fxYear": 2022
  },
  "SE": {
    "name": "Sweden",
    "iso3": "SWE",
    "currency": "sek",
    "incomeLevel": "HIC",
    "ppp": 8.548493,
    "pppYear": 2025,
    "fx": 9.82070570950185,
    "fxYear": 2025
  },
  "SG": {
    "name": "Singapore",
    "iso3": "SGP",
    "currency": "sgd",
    "incomeLevel": "HIC",
    "ppp": 0.790885710223008,
    "pppYear": 2025,
    "fx": 1.30745,
    "fxYear": 2025
  },
  "SH": {
    "name": "St. Helena",
    "iso3": "",
    "currency": "shp",
    "incomeLevel": "HIC",
    "ppp": 0.677133,
    "pppYear": 2025,
    "fx": 0.759473957338608,
    "fxYear": 2025,
    "pricingDataType": "territory_proxy",
    "pricingProxyCountryCode": "GB",
    "pricingCurrencyMultiplier": 1
  },
  "SI": {
    "name": "Slovenia",
    "iso3": "SVN",
    "currency": "eur",
    "incomeLevel": "HIC",
    "ppp": 0.558308,
    "pppYear": 2025,
    "fx": 0.88496895841236,
    "fxYear": 2025
  },
  "SJ": {
    "name": "Svalbard & Jan Mayen",
    "iso3": "",
    "currency": "nok",
    "incomeLevel": "HIC",
    "ppp": 9.451661,
    "pppYear": 2025,
    "fx": 10.3958333333333,
    "fxYear": 2025,
    "pricingDataType": "territory_proxy",
    "pricingProxyCountryCode": "NO",
    "pricingCurrencyMultiplier": 1
  },
  "SK": {
    "name": "Slovak Republic",
    "iso3": "SVK",
    "currency": "eur",
    "incomeLevel": "HIC",
    "ppp": 0.512288,
    "pppYear": 2025,
    "fx": 0.88496895841236,
    "fxYear": 2025
  },
  "SL": {
    "name": "Sierra Leone",
    "iso3": "SLE",
    "currency": "sle",
    "incomeLevel": "LIC",
    "ppp": 5.15883670629659,
    "pppYear": 2025,
    "fx": 21.3048751103818,
    "fxYear": 2023
  },
  "SM": {
    "name": "San Marino",
    "iso3": "SMR",
    "currency": "eur",
    "incomeLevel": "HIC",
    "ppp": 0.702590229204567,
    "pppYear": 2023,
    "fx": 0.887144250370588,
    "fxYear": 2025
  },
  "SN": {
    "name": "Senegal",
    "iso3": "SEN",
    "currency": "xof",
    "incomeLevel": "LMC",
    "ppp": 208.211053506783,
    "pppYear": 2025,
    "fx": 581.92848104034,
    "fxYear": 2025
  },
  "SO": {
    "name": "Somalia, Fed. Rep.",
    "iso3": "SOM",
    "currency": "sos",
    "incomeLevel": "LIC",
    "ppp": 12115.8880855469,
    "pppYear": 2025,
    "fx": 23097.9873219373,
    "fxYear": 2017
  },
  "SR": {
    "name": "Suriname",
    "iso3": "SUR",
    "currency": "srd",
    "incomeLevel": "UMC",
    "ppp": 11.6290001939516,
    "pppYear": 2025,
    "fx": 37.2601791666667,
    "fxYear": 2025
  },
  "SS": {
    "name": "South Sudan",
    "iso3": "SSD",
    "currency": "ssp",
    "incomeLevel": "LIC",
    "ppp": 126.743049621582,
    "pppYear": 2021,
    "fx": 2163.10387269883,
    "fxYear": 2024
  },
  "ST": {
    "name": "Sao Tome and Principe",
    "iso3": "STP",
    "currency": "stn",
    "incomeLevel": "LMC",
    "ppp": 13.8672557039219,
    "pppYear": 2025,
    "fx": 22.6430098947812,
    "fxYear": 2024
  },
  "SV": {
    "name": "El Salvador",
    "iso3": "SLV",
    "currency": "usd",
    "incomeLevel": "UMC",
    "ppp": 0.408953489712557,
    "pppYear": 2025,
    "fx": 1,
    "fxYear": 2025
  },
  "SX": {
    "name": "Sint Maarten (Dutch part)",
    "iso3": "SXM",
    "currency": "xcg",
    "incomeLevel": "HIC",
    "ppp": 1.36183701233079,
    "pppYear": 2025,
    "fx": 1.79,
    "fxYear": 2025
  },
  "SY": {
    "name": "Syrian Arab Republic",
    "iso3": "SYR",
    "currency": "syp",
    "incomeLevel": "LIC",
    "ppp": 807.95702765744,
    "pppYear": 2022,
    "fx": 2505.74691085873,
    "fxYear": 2022
  },
  "SZ": {
    "name": "Eswatini",
    "iso3": "SWZ",
    "currency": "szl",
    "incomeLevel": "LMC",
    "ppp": 5.86563643135325,
    "pppYear": 2025,
    "fx": 17.8889209208377,
    "fxYear": 2025
  },
  "TA": {
    "name": "Tristan da Cunha",
    "iso3": "",
    "currency": "gbp",
    "incomeLevel": "HIC",
    "ppp": 0.677133,
    "pppYear": 2025,
    "fx": 0.759473957338608,
    "fxYear": 2025,
    "pricingDataType": "territory_proxy",
    "pricingProxyCountryCode": "GB",
    "pricingCurrencyMultiplier": 1
  },
  "TC": {
    "name": "Turks and Caicos Islands",
    "iso3": "TCA",
    "currency": "usd",
    "incomeLevel": "HIC",
    "ppp": 0.986773622391009,
    "pppYear": 2024,
    "fx": 1,
    "fxYear": 2025
  },
  "TD": {
    "name": "Chad",
    "iso3": "TCD",
    "currency": "xaf",
    "incomeLevel": "LIC",
    "ppp": 204.953276226313,
    "pppYear": 2025,
    "fx": 581.92848104034,
    "fxYear": 2025
  },
  "TF": {
    "name": "French Southern Territories",
    "iso3": "",
    "currency": "eur",
    "incomeLevel": "HIC",
    "ppp": 0.677618,
    "pppYear": 2025,
    "fx": 0.88496895841236,
    "fxYear": 2025,
    "pricingDataType": "territory_proxy",
    "pricingProxyCountryCode": "FR",
    "pricingCurrencyMultiplier": 1
  },
  "TG": {
    "name": "Togo",
    "iso3": "TGO",
    "currency": "xof",
    "incomeLevel": "LMC",
    "ppp": 197.415755247599,
    "pppYear": 2025,
    "fx": 581.92848104034,
    "fxYear": 2025
  },
  "TH": {
    "name": "Thailand",
    "iso3": "THA",
    "currency": "thb",
    "incomeLevel": "UMC",
    "ppp": 10.0922556843405,
    "pppYear": 2025,
    "fx": 32.882809252867,
    "fxYear": 2025
  },
  "TJ": {
    "name": "Tajikistan",
    "iso3": "TJK",
    "currency": "tjs",
    "incomeLevel": "LMC",
    "ppp": 2.76890578758637,
    "pppYear": 2025,
    "fx": 10.0177083333333,
    "fxYear": 2025
  },
  "TK": {
    "name": "Tokelau",
    "iso3": "",
    "currency": "nzd",
    "incomeLevel": "HIC",
    "ppp": 1.472957,
    "pppYear": 2025,
    "fx": 1.72010833333333,
    "fxYear": 2025,
    "pricingDataType": "territory_proxy",
    "pricingProxyCountryCode": "NZ",
    "pricingCurrencyMultiplier": 1
  },
  "TL": {
    "name": "Timor-Leste",
    "iso3": "TLS",
    "currency": "usd",
    "incomeLevel": "LMC",
    "ppp": 0.278816251223677,
    "pppYear": 2025,
    "fx": 1,
    "fxYear": 2025
  },
  "TM": {
    "name": "Turkmenistan",
    "iso3": "TKM",
    "currency": "tmt",
    "incomeLevel": "UMC",
    "ppp": 1.57315223779675,
    "pppYear": 2025,
    "fx": 5200,
    "fxYear": 2001
  },
  "TN": {
    "name": "Tunisia",
    "iso3": "TUN",
    "currency": "tnd",
    "incomeLevel": "LMC",
    "ppp": 0.916013551631524,
    "pppYear": 2025,
    "fx": 3.10745,
    "fxYear": 2024
  },
  "TO": {
    "name": "Tonga",
    "iso3": "TON",
    "currency": "top",
    "incomeLevel": "UMC",
    "ppp": 1.80792099963135,
    "pppYear": 2025,
    "fx": 2.41052686435725,
    "fxYear": 2025
  },
  "TR": {
    "name": "Turkiye",
    "iso3": "TUR",
    "currency": "try",
    "incomeLevel": "UMC",
    "ppp": 16.203626,
    "pppYear": 2025,
    "fx": 39.4548130977983,
    "fxYear": 2025
  },
  "TT": {
    "name": "Trinidad and Tobago",
    "iso3": "TTO",
    "currency": "ttd",
    "incomeLevel": "HIC",
    "ppp": 3.44833404244324,
    "pppYear": 2025,
    "fx": 6.74884660621027,
    "fxYear": 2025
  },
  "TV": {
    "name": "Tuvalu",
    "iso3": "TUV",
    "currency": "aud",
    "incomeLevel": "UMC",
    "ppp": 1.38717699395366,
    "pppYear": 2025,
    "fx": 1.5519978866485,
    "fxYear": 2025
  },
  "TW": {
    "name": "Taiwan",
    "iso3": "TWN",
    "currency": "twd",
    "incomeLevel": "HIC",
    "ppp": 17.88595880917184,
    "pppYear": 2025,
    "fx": 31.166,
    "fxYear": 2025,
    "pricingDataType": "regional_ppp_proxy",
    "pricingProxyCountryCode": "KR"
  },
  "TZ": {
    "name": "Tanzania",
    "iso3": "TZA",
    "currency": "tzs",
    "incomeLevel": "LMC",
    "ppp": 749.533488393139,
    "pppYear": 2025,
    "fx": 2597.90041666667,
    "fxYear": 2024
  },
  "UA": {
    "name": "Ukraine",
    "iso3": "UKR",
    "currency": "uah",
    "incomeLevel": "UMC",
    "ppp": 12.9353983614283,
    "pppYear": 2025,
    "fx": 41.6890720433333,
    "fxYear": 2025
  },
  "UG": {
    "name": "Uganda",
    "iso3": "UGA",
    "currency": "ugx",
    "incomeLevel": "LIC",
    "ppp": 1271.51526728309,
    "pppYear": 2025,
    "fx": 3602.98994206814,
    "fxYear": 2025
  },
  "UM": {
    "name": "U.S. Outlying Islands",
    "iso3": "",
    "currency": "usd",
    "incomeLevel": "HIC",
    "ppp": 1,
    "pppYear": 2025,
    "fx": 1,
    "fxYear": 2025,
    "pricingDataType": "territory_proxy",
    "pricingProxyCountryCode": "US",
    "pricingCurrencyMultiplier": 1
  },
  "US": {
    "name": "United States",
    "iso3": "USA",
    "currency": "usd",
    "incomeLevel": "HIC",
    "ppp": 1,
    "pppYear": 2025,
    "fx": 1,
    "fxYear": 2025
  },
  "UY": {
    "name": "Uruguay",
    "iso3": "URY",
    "currency": "uyu",
    "incomeLevel": "HIC",
    "ppp": 27.108346862201,
    "pppYear": 2025,
    "fx": 41.1909791666667,
    "fxYear": 2025
  },
  "UZ": {
    "name": "Uzbekistan",
    "iso3": "UZB",
    "currency": "uzs",
    "incomeLevel": "LMC",
    "ppp": 3670.12629350113,
    "pppYear": 2025,
    "fx": 12579.3943476702,
    "fxYear": 2025
  },
  "VA": {
    "name": "Vatican City",
    "iso3": "",
    "currency": "eur",
    "incomeLevel": "HIC",
    "ppp": 0.610275,
    "pppYear": 2025,
    "fx": 0.88496895841236,
    "fxYear": 2025,
    "pricingDataType": "territory_proxy",
    "pricingProxyCountryCode": "IT",
    "pricingCurrencyMultiplier": 1
  },
  "VC": {
    "name": "St. Vincent and the Grenadines",
    "iso3": "VCT",
    "currency": "xcd",
    "incomeLevel": "UMC",
    "ppp": 1.48761704067186,
    "pppYear": 2025,
    "fx": 2.7,
    "fxYear": 2025
  },
  "VE": {
    "name": "Venezuela, RB",
    "iso3": "VEN",
    "currency": "ves",
    "incomeLevel": "LMC",
    "ppp": 2.68098258972168e-11,
    "pppYear": 2011,
    "fx": 9.975,
    "fxYear": 2017
  },
  "VG": {
    "name": "British Virgin Islands",
    "iso3": "VGB",
    "currency": "usd",
    "incomeLevel": "HIC",
    "ppp": 1.02022969722748,
    "pppYear": 2017,
    "fx": null,
    "fxYear": null
  },
  "VI": {
    "name": "Virgin Islands (U.S.)",
    "iso3": "VIR",
    "currency": "usd",
    "incomeLevel": "HIC",
    "ppp": 0.890243717259396,
    "pppYear": 2022,
    "fx": 1,
    "fxYear": 2025
  },
  "VN": {
    "name": "Viet Nam",
    "iso3": "VNM",
    "currency": "vnd",
    "incomeLevel": "UMC",
    "ppp": 6990.87070514029,
    "pppYear": 2025,
    "fx": 24164.8858333333,
    "fxYear": 2024
  },
  "VU": {
    "name": "Vanuatu",
    "iso3": "VUT",
    "currency": "vuv",
    "incomeLevel": "LMC",
    "ppp": 107.389043283146,
    "pppYear": 2025,
    "fx": 119.165,
    "fxYear": 2024
  },
  "WF": {
    "name": "Wallis & Futuna",
    "iso3": "",
    "currency": "xpf",
    "incomeLevel": "HIC",
    "ppp": 80.8613078906,
    "pppYear": 2025,
    "fx": 105.60485025457622,
    "fxYear": 2025,
    "pricingDataType": "territory_proxy",
    "pricingProxyCountryCode": "FR",
    "pricingCurrencyMultiplier": 119.3317
  },
  "WS": {
    "name": "Samoa",
    "iso3": "WSM",
    "currency": "wst",
    "incomeLevel": "UMC",
    "ppp": 1.75413819197732,
    "pppYear": 2025,
    "fx": 2.79150381915391,
    "fxYear": 2025
  },
  "XK": {
    "name": "Kosovo",
    "iso3": "XKX",
    "currency": "eur",
    "incomeLevel": "UMC",
    "ppp": 0.362904088534196,
    "pppYear": 2025,
    "fx": 0.887144250370588,
    "fxYear": 2025
  },
  "YE": {
    "name": "Yemen, Rep.",
    "iso3": "YEM",
    "currency": "yer",
    "incomeLevel": "LIC",
    "ppp": 93.6313171386719,
    "pppYear": 2013,
    "fx": 1355.11637864823,
    "fxYear": 2023
  },
  "YT": {
    "name": "Mayotte",
    "iso3": "",
    "currency": "eur",
    "incomeLevel": "HIC",
    "ppp": 0.677618,
    "pppYear": 2025,
    "fx": 0.88496895841236,
    "fxYear": 2025,
    "pricingDataType": "territory_proxy",
    "pricingProxyCountryCode": "FR",
    "pricingCurrencyMultiplier": 1
  },
  "ZA": {
    "name": "South Africa",
    "iso3": "ZAF",
    "currency": "zar",
    "incomeLevel": "UMC",
    "ppp": 7.42029658394341,
    "pppYear": 2025,
    "fx": 17.8887489855833,
    "fxYear": 2025
  },
  "ZM": {
    "name": "Zambia",
    "iso3": "ZMB",
    "currency": "zmw",
    "incomeLevel": "LMC",
    "ppp": 7.56139268212565,
    "pppYear": 2025,
    "fx": 25.2756892021939,
    "fxYear": 2025
  },
  "ZW": {
    "name": "Zimbabwe",
    "iso3": "ZWE",
    "currency": "usd",
    "incomeLevel": "LMC",
    "ppp": null,
    "pppYear": null,
    "fx": 1,
    "fxYear": 2025,
    "pricingDataType": "settlement_currency_override",
    "pricingProxyCountryCode": "US"
  }
});
